import { useTypedRouteLoaderData } from 'remix-typedjson';
import { type loader as rootLoader } from '#speaker-shop/root';

/**
 * Returns the current voice slug from the root loader data.
 *
 * Used by legacy shops where the voice is selected through the subdomain or URL path.
 * Unified shops select voices by SpeakerVoice ID and do not expose a voice slug.
 */
export function useVoiceSlug(): string | undefined {
    const rootData = useTypedRouteLoaderData<typeof rootLoader>('root');
    if (rootData && 'voiceSlug' in rootData && rootData.voiceSlug) {
        return rootData.voiceSlug;
    }
    return undefined;
}
